module.exports = __webpack_public_path__ + "static/24cash_logo-d379b0283218d87e94f49342b75114d8.jpg";